import { useI18n } from '@/i18n'

export const EMPTY_VALUE = '\u2013'

export interface EmptyValueProps {
  class?: string
}

export function EmptyValue(props: EmptyValueProps) {
  const { t } = useI18n()
  return (
    <span class={`relative ${props.class ?? ''}`.trim()}>
      <span aria-hidden="true">{EMPTY_VALUE}</span>
      <span class="sr-only">{t('designSystem.emptyValue.label')}</span>
    </span>
  )
}
